export const SET_USER = 'USER/SET_USER'

export const LOGOUT_USER = 'USER/LOGOUT_USER'

export const USER_INFO = 'USER/USER_INFO'

export const AUTORIZAR = 'USER/AUTORIZAR'

export const PERMITIDO = 'USER/PERMITIDO'

export const CARREGAR_INFOS = 'USER/CARREGAR_INFOS'

export const OBTER_ACESSOS = 'USER/OBTER_ACESSOS'
